module.exports = __webpack_public_path__ + "static/media/automation.e4506eb2.png";